// extracted by mini-css-extract-plugin
module.exports = {"container":"packages-core-App-AddToHomeScreen-style__container--1pV4K"};